import { Hero } from "@/components/Hero";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { HERO_LAYOUTS } from "@/lib/heroImage";
import { HeroScrollStory } from "./HeroScrollStory";
import { IntegratedSection } from "./IntegratedSection";

export function HeroSection() {
  // Portrait screens get the stacked hero: a full-height card would be a tall,
  // narrow crop of a landscape photo.
  const isLandscapeDesktop = useMediaQuery(HERO_LAYOUTS.scrollStory.media);
  if (isLandscapeDesktop) {
    return <HeroScrollStory />;
  }
  return (
    <>
      <Hero />
      <IntegratedSection />
    </>
  );
}
